import type { Action } from './actions'
import { managePageAPIError } from 'shared/store/utils'
import endpoints from 'shared/store/endpoints'
import type { LotteryGain, LotteryOperation } from 'shared/types'

export type State = {
    cannotPlayReasonKey?: string,
    gain?: LotteryGain,
    gifUrl: string,
    allowedToPlayAfterDateWithoutKingdomPoint?: string,
    canPlayWithKingdomPoints?: boolean,
    dataLoaded?: boolean,
    openingDateNextLottery?: string,
    operation?: LotteryOperation,
    error?: any,
    networkError?: any
}

const initialState: State = {
    available: false,
    gifUrl: '',
    allowedToPlayAfterDateWithoutKingdomPoint: undefined,
    canPlayWithKingdomPoints: false,
    openingDateNextLottery: undefined,
    operation: undefined
}

export const reducer = (state: State = initialState, action: Action): State => {
    switch (action.type) {
        case 'PAGE_DATA_LOTTERY_RESPONSE':
            return {
                ...state,
                ...action.data,
                dataLoaded: true,
                error: undefined,
                networkError: undefined
            }
        case 'FETCH_LOTTERY_GAIN':
            const { gifUrl, ...gain } = action.lotteryGainCustomer
            return {
                ...state,
                gifUrl,
                gain: { ...gain }
            }
        case 'PAGE_API_ERROR':
            return managePageAPIError(
                state,
                action,
                endpoints.kingdom.lottery.page
            )
        case 'RESET_NETWORK_ERROR':
            return {
                ...state,
                networkError: undefined
            }
        case 'PAGE_NETWORK_ERROR':
            return {
                ...state,
                networkError: action.networkError,
                error: undefined
            }
        default:
            return state
    }
}
